module.exports = __webpack_public_path__ + "static/media/poster.c37f565f.png";